<template>
    <carousel :classes="classes" :items="items" :options="options" :show-navigation="showNavigation">
        <template #slide="{ item }">
            <comparison-card :product="item"></comparison-card>
        </template>
    </carousel>
</template>

<script>
import Carousel from "./Carousel";
import windowWidth from "../../mixins/windowWidth";

export default {
    props: {
        items: {},
        classes: {
            type: String,
            default: () => ''
        }
    },
    components: {
        Carousel,
    },
    mixins: [
        windowWidth
    ],
    data() {
        return {
            options: {
                spaceBetween: 5,
                breakpoints: {
                    1200: {
                        slidesPerView: 5,
                    },
                    1024: {
                        slidesPerView: 4,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    320: {
                        slidesPerView: 2,
                    }
                },
            },
        }
    },
    computed: {
        showNavigation() {
            return !this.$q.platform.is.mobile
                && !(this.items.length <= 1
                || (this.windowWidth <= 640 && this.items.length <= 2)
                || (this.windowWidth <= 768 && this.items.length <= 3)
                || (this.windowWidth <= 1024 && this.items.length <= 4)
                || ((this.windowWidth <= 1200 || this.windowWidth > 1200) && this.items.length <= 5)
            );
        }
    }
}
</script>
